import { InferType } from 'yup'
import * as yup from 'yup'

import { TTranslationFunction } from '@/types'

import { nameSchema, urlSchema } from '../fieldSchemas'

export const getSocialLinksFormSchema = (t: TTranslationFunction) => {
	const socialLinkFieldSchema = yup.object({
		platformId: yup.string().required(),
		name: nameSchema(t, { required: true }) as yup.StringSchema<string>,
		url: urlSchema(t, { required: true }),
		description: yup.string().notRequired(),
		logo: yup
			.object({
				src: yup.string().notRequired(),
				provider: yup.string().notRequired(),
			})
			.notRequired(),
	})

	return yup
		.object({
			socialLinks: yup
				.array(socialLinkFieldSchema)
				.required()
				.when('$isSocialMediaQrType', {
					is: true,
					then: (schema) => schema.min(1),
				}),

			customSocialLink: yup
				.object({
					platformId: yup.string().when('$isAddingCustomSocial', {
						is: true,
						then: (fieldSchema) => fieldSchema.required(),
						otherwise: (fieldSchema) => fieldSchema.notRequired(),
					}),
					name: yup.string().when('$isAddingCustomSocial', {
						is: true,
						then: () => nameSchema(t, { required: true }),
						otherwise: (fieldSchema) => fieldSchema.notRequired(),
					}),
					url: yup.string().when('$isAddingCustomSocial', {
						is: true,
						then: () => urlSchema(t, { required: true }),
						otherwise: (fieldSchema) => fieldSchema.notRequired(),
					}),
					description: yup.string().notRequired(),
					logo: yup.lazy((value) => {
						if (
							value &&
							typeof value === 'object' &&
							Object.keys(value).length > 0
						) {
							return yup.object({
								src: yup.string().nullable().notRequired(),
								provider: yup.string().notRequired(),
								bucketRootUrl: yup.string().notRequired(),
								bytes: yup.number().notRequired(),
								format: yup.string().notRequired(),
								publicId: yup.string().notRequired(),
								resourceType: yup.string().notRequired(),
							})
						}
						return yup.mixed().nullable().notRequired()
					}),
				})
				.notRequired(),
		})
		.required()
}

export type TSocialLinksFormFields = InferType<
	ReturnType<typeof getSocialLinksFormSchema>
>

export type TSocialLinkField = Omit<
	NonNullable<TSocialLinksFormFields['socialLinks']>[number],
	'platformId' | 'description' | 'logo'
> & {
	platformId?: string
	description?: string
	logo?: {
		src?: string
		provider?: string
		publicId?: string
		bucketRootUrl?: string
		format?: string
		resourceType?: string
		bytes?: number
	}
}
